import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from 'prop-types';

import * as authAction from "../../actions/authActions";

import Modal from "reboron/DropModal";
import * as userAction from "../../actions/userAction";
import UserPasswordView from "../../components/UserPasswordView";
import UserInfo from "../../components/UserInfo";

const stickyStyles = {
  //position: '-webkit-sticky', //safari support
  position: "sticky",
  //position: 'fixed', // added to support older browsers
  top: 0,
  zIndex: 99 //https://stackoverflow.com/questions/15667784/image-visible-over-fixed-header
};

/**
 * Nagłowek głownej strony
 */
class Header extends Component {

  /**
 * Pokazuje modal
 */
  showModal() {
    this.refs.modal.show();
  }

  /**
   * Chowa modal
   */
  hideModal = () => {
    this.refs.modal.hide();
  };

  /**
  * Akcja po zatwierdzeniu aktualizacji hasła
  */
  onUpdatePasswordAction = data => {
    this.props.onUpdatePassword(data);
    this.hideModal();
  };

  /**
   * Akcja na klik edycji wiersza w tabelce -hasło
   */
  onEditPasswdClick = () => {
    this.showModal();
  };

  /**
   * Akcja na klik przycisku dodania
   */
  onPowerOffButtonClick = () => {
    this.props.onLogout();
  };

  render() {

    let { authenticatedUser, formatMessage } = this.props;

    return (
      <div className="w3-top">
        <header className="w3-theme-dark w3-large" style={stickyStyles}>

          <button
            className="w3-bar-item w3-button w3-hover-none w3-hover-text-black w3-right"
            onClick={() => this.onPowerOffButtonClick()}
          >
            <i className="fa fa-power-off" />
          </button>

          <button className="w3-bar-item w3-button w3-hover-none w3-hover-text-black w3-hide-large">
            <i className="fa fa-bars" />
          </button>
          <span className="w3-bar-item w3-padding w3-left">
            flow24.pl
          </span>

          <div className="w3-dropdown-hover w3-right">
            <button className="w3-button w3-hover-none w3-hover-text-black"><i className="fa fa-user" /></button>
            <div className="w3-dropdown-content w3-bar-block w3-black w3-animated" style={{ right: 0 }}>
              <button className="w3-bar-item w3-button w3-hover-none w3-hover-text-theme" onClick={() => this.onEditPasswdClick()}>Zmień hasło</button>
            </div>
          </div>

          {/*przejscie do strony settings
          <Link
            to="/settings"
            className="w3-button w3-hover-none w3-hover-text-black w3-right"
          >
            <i className="fa fa-user" />
          </Link>
          */}

          <span className="w3-bar-item w3-padding w3-right">
            <UserInfo user={authenticatedUser} />
          </span>

          <div className="w3-clear"></div>

        </header>

        <Modal ref={"modal"}>
          <UserPasswordView
            title={formatMessage("app.settingsPage.editUserPassword")}
            userId={authenticatedUser.id}
            cancelText={formatMessage("app.action.cancel")}
            sumbitText={formatMessage("app.action.submit")}
            onCancel={this.hideModal}
            onSubmit={this.onUpdatePasswordAction}
          />
        </Modal>
      </div>
    );
  }
}

Header.propTypes = {
  formatMessage: PropTypes.func.isRequired,
  authenticatedUser: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    onLogout: () => {
      dispatch(authAction.doLogout());
    },
    onUpdatePassword: userPassword => {
      dispatch(userAction.updateUserPassword(userPassword));
    }
  };
};

export default connect(
  null,
  mapDispatchToProps
)(Header);
